import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { ComumModule } from './../../../shared/comum.module';
import { translateLoaderNBS } from './../../../shared/translate-loader/translateLoader';
import { ProdutividadeIndiceCadastroComponent } from './produtividade-indice-cadastro/produtividade-indice-cadastro.component';
import { ProdutividadeIndiceListaComponent } from './produtividade-indice-lista/produtividade-indice-lista.component';
import { ProdutividadeIndiceService } from './produtividade-indice-service/produtividade-indice.service';
import { ProdutividadeIndiceComponent } from './produtividade-indice.component';

@NgModule({
    imports: [
        HttpClientModule,
        FormsModule,
        CommonModule,
        BrowserModule,
        ReactiveFormsModule,
        ComumModule,
        TranslateModule.forRoot(translateLoaderNBS)
    ],
    exports: [
        ProdutividadeIndiceComponent
    ],
    declarations: [
        ProdutividadeIndiceComponent,
        ProdutividadeIndiceListaComponent,
        ProdutividadeIndiceCadastroComponent
    ],
    providers: [
        ProdutividadeIndiceService,
    ]
})
export class ProdutividadeIndiceModule {

}
